import React from 'react';

import cn from 'classnames';
import VideoHls from 'react-scale/components/tailwind/VideoHls';

class TaskResponseVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAnnotations: false
    };
    this.originalRef = React.createRef();
    this.annotatedRef = React.createRef();
  }

  onShowAnnotations = () => {
    const original = this.originalRef.current;
    const annotated = this.annotatedRef.current;
    original.pause();
    const currentTime = original.getCurrentTime();
    annotated.seekTo(currentTime);
    annotated.play();
    this.setState({ showAnnotations: true });
  };

  render() {
    const { showAnnotations } = this.state;
    return (
      <>
        <VideoHls
          src={`https://stream.mux.com/${this.props.originalMuxPlaybackID}.m3u8`}
          poster={`https://image.mux.com/${this.props.originalMuxPlaybackID}/thumbnail.png?width=20&fit_mode=pad&time=0`}
          muted
          playsinline
          controls={false}
          autoPlay
          loop
          playStopOnViewportChange
          ref={this.originalRef}
        />
        <div
          className={cn('absolute inset-0 z-10 opacity-0 tansition-all transition-250', {
            'opacity-100': showAnnotations
          })}
        >
          <VideoHls
            src={`https://stream.mux.com/${this.props.annotatedMuxPlaybackID}.m3u8`}
            poster={`https://image.mux.com/${this.props.annotatedMuxPlaybackID}/thumbnail.png?width=20&fit_mode=pad&time=0`}
            muted
            playsinline
            controls={false}
            autoPlay
            loop
            playStopOnViewportChange
            ref={this.annotatedRef}
          />
        </div>
      </>
    );
  }
}

export default TaskResponseVideo;
